import type { PurchaseReturnRow, ReturnReason, SalesReturnRow } from './types';

export interface SalesReturnsQuery {
  from: string;
  to: string;
  sid?: number | null;
  slid?: string;
  reason?: ReturnReason | 'all';
  limit?: number;
}

export interface PurchaseReturnsQuery {
  from: string;
  to: string;
  sid?: number | null;
  sup_id?: string;
  limit?: number;
}

function buildQS(params: { [k: string]: unknown }): string {
  const parts: string[] = [];
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  }
  return parts.length ? '?' + parts.join('&') : '';
}

async function fetchJSON<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: 'same-origin' });
  if (res.status === 401) throw new Error('unauthenticated');
  if (res.status === 403) throw new Error('forbidden');
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
  return (await res.json()) as T;
}

export function fetchSalesReturns(q: SalesReturnsQuery): Promise<SalesReturnRow[]> {
  return fetchJSON<SalesReturnRow[]>('/api/sales-returns' + buildQS({ ...q }));
}

export function fetchPurchaseReturns(q: PurchaseReturnsQuery): Promise<PurchaseReturnRow[]> {
  return fetchJSON<PurchaseReturnRow[]>('/api/purchase-returns' + buildQS({ ...q }));
}
